import { render } from "./Or_selectProject.vue?vue&type=template&id=1ed9109c&scoped=true&ts=true"
import script from "./Or_selectProject.vue?vue&type=script&lang=ts"
export * from "./Or_selectProject.vue?vue&type=script&lang=ts"

import "./Or_selectProject.vue?vue&type=style&index=0&id=1ed9109c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed9109c"]])

export default __exports__